import { FormControl, TextField, MenuItem, Stack, alpha } from "@mui/material";
import { useTheme } from "@mui/system";
import { useTranslation } from "react-i18next";

/**
 * Device claim form component for entering claim code and selecting organization
 * @param {Object} props - Component props
 * @param {string} props.claimCode - Current claim code value
 * @param {Function} props.onClaimCodeChange - Callback for claim code changes
 * @param {string} props.organisationID - Selected organization ID
 * @param {Function} props.onOrganisationChange - Callback for organization changes
 * @param {Array} props.organisations - Available organizations
 * @returns {JSX.Element} Device claim form component
 */
export const DeviceClaimForm = ({
  claimCode,
  onClaimCodeChange,
  organisationID,
  onOrganisationChange,
  organisations,
}) => {
  const { t } = useTranslation("common");
  const theme = useTheme();

  const textFieldStyle = {
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      backgroundColor: alpha(theme.palette.background.paper, 0.8),
      "&:hover": {
        boxShadow: "0 0 0 2px rgba(25, 118, 210, 0.1)",
      },
      "&.Mui-focused": {
        boxShadow: "0 0 0 2px rgba(25, 118, 210, 0.2)",
      },
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: alpha(theme.palette.divider, 0.3),
    },
    "& .MuiInputLabel-root": {
      fontSize: "0.875rem",
      fontWeight: 500,
    },
  };

  return (
    <Stack spacing={2}>
      <FormControl fullWidth>
        <TextField
          id="claim_code"
          label={t("common.claim_code")}
          variant="outlined"
          value={claimCode}
          onChange={(e) => onClaimCodeChange(e.target.value)}
          sx={textFieldStyle}
        />
      </FormControl>

      <FormControl fullWidth>
        <TextField
          id="organisation_id"
          label={t("common.organisation")}
          variant="outlined"
          select
          onChange={(event) => onOrganisationChange(event.target.value)}
          value={organisationID || ""}
          sx={textFieldStyle}
        >
          {organisations &&
            organisations.length > 0 &&
            organisations.map((organisation) => (
              <MenuItem key={organisation.id} value={organisation.id}>
                {organisation.name}
              </MenuItem>
            ))}
        </TextField>
      </FormControl>
    </Stack>
  );
};
